import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Select from "react-select"
import Flatpickr from "react-flatpickr"
import TableComponent from "components/Table"
import userReportListColumns from "./userReportListColumns"
import {
  downloadBookingUserReports,
  getUserBookingReports,
  getUsersBySearch,
  resetUsersBySearch,
} from "store/actions"
import { getUpdatedCheckedItemsList, useQuery } from "utils"
import { URL_PATHS } from "constants/index"

const UserReports = ({
  history,
  getUsersBySearch,
  usersBySearch,
  userBookingReports,
  getUserBookingReports,
  match,
  resetUsersBySearch,
  downloadBookingUserReports,
}) => {
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [userValue, setUserValue] = useState(null)
  const [checkedItems, setCheckedItems] = useState([])
  const [defaultOrder, setDefaultOrder] = useState({
    o: "bookings_count",
    od: "desc",
  })
  const { event_id } = match?.params
  const query = useQuery()
  const calendar_id = query.get("calendar_id")
  const booking_type_id = query.get("booking_type_id")
  let timeOut = null

  useEffect(() => {
    getUserBookingReports({
      ...defaultOrder,
      ...(calendar_id ? { calendar_id: calendar_id } : {}),
      ...(booking_type_id ? { booking_type_id: booking_type_id } : {}),
    })
  }, [])

  const searchHandler = () => {
    getUserBookingReports({
      ...defaultOrder,
      ...(calendar_id ? { calendar_id: calendar_id } : {}),
      ...(booking_type_id ? { booking_type_id: booking_type_id } : {}),
      ...(userValue?.value ? { user_id: userValue?.value } : {}),
      page: 1,
      start: startDate,
      end: endDate,
    })
    setShowResetButton(true)
    setCheckedItems([])
  }

  const resetSearchHandler = () => {
    getUserBookingReports({
      ...defaultOrder,
      page: 1,
      ...(calendar_id ? { calendar_id: calendar_id } : {}),
      ...(booking_type_id ? { booking_type_id: booking_type_id } : {}),
    })
    setShowResetButton(false)
    setStartDate("")
    setEndDate("")
    setUserValue(null)
    setCheckedItems([])
  }

  const handlePageChange = page => {
    getUserBookingReports({
      page: page,
      ...(calendar_id ? { calendar_id: calendar_id } : {}),
      ...(booking_type_id ? { booking_type_id: booking_type_id } : {}),
      ...defaultOrder,
      start: startDate,
      end: endDate,
      ...(userValue?.value ? { user_id: userValue?.value } : {}),
    })
    setCheckedItems([])
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getUserBookingReports({
      o: sortField,
      od: sortOrder,
      page: 1,
      ...(calendar_id ? { calendar_id: calendar_id } : {}),
      ...(booking_type_id ? { booking_type_id: booking_type_id } : {}),
      ...(userValue?.value ? { user_id: userValue?.value } : {}),
      start: startDate,
      end: endDate,
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
    setCheckedItems([])
  }

  const handleCheckItem = (item, checked) => {
    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = []
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        list.push(items[i].id)
      }
    }
    setCheckedItems(list)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="User Reports" />
          <BreadcrumbTitle
            title="User Reports"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              {
                title: "Bookings",
                link: generatePath(URL_PATHS.BOOKING_CALENDAR_REPORTS, {
                  event_id: event_id,
                }),
              },
              { title: "User Reports" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          <Card>
            <CardBody>
              <Row className="justify-content-center">
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="Start Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={startDate}
                    onChange={(selectedDates, dateStr) => {
                      setStartDate(dateStr)
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="End Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={endDate}
                    onChange={(selectedDates, dateStr) => {
                      setEndDate(dateStr)
                    }}
                  />
                </Col>
                <Col xl={2} className="my-1">
                  <Select
                    value={userValue}
                    placeholder="Search by user"
                    onInputChange={(newValue, actionMeta) => {
                      if (timeOut) {
                        clearTimeout(timeOut)
                      }
                      timeOut = setTimeout(() => {
                        if (actionMeta?.action === "input-change") {
                          getUsersBySearch({ t: newValue })
                        }
                      }, 300)
                    }}
                    options={usersBySearch?.map(item => ({
                      label: item?.first_name + " " + item?.last_name,
                      value: item?.id,
                    }))}
                    onChange={value => setUserValue(value)}
                    isClearable={true}
                    onMenuClose={() => {
                      resetUsersBySearch()
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <SaveButton
                    type="button"
                    content="Search"
                    onClick={searchHandler}
                  />
                </Col>
                {showResetButton && (
                  <Col xs="auto" className="my-1">
                    <SaveButton
                      type="button"
                      content="Reset"
                      color="light"
                      onClick={resetSearchHandler}
                    />
                  </Col>
                )}
              </Row>
              <Row>
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Send Email"
                    disabled={checkedItems?.length === 0}
                    onClick={() => {
                      localStorage.setItem(
                        "commUsers",
                        JSON.stringify(checkedItems)
                      )
                      history.push(`/add-custom-email`)
                    }}
                  />
                </Col>
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Send Notification"
                    disabled={checkedItems?.length === 0}
                    onClick={() => {
                      localStorage.setItem(
                        "commUsers",
                        JSON.stringify(checkedItems)
                      )
                      history.push(`/add-notification`)
                    }}
                  />
                </Col>
                <Col className="text-end">
                  <SaveButton
                    type="button"
                    content="Download Report"
                    disabled={userBookingReports?.data?.length === 0}
                    onClick={() => {
                      downloadBookingUserReports({
                        download: 1,
                        ...defaultOrder,
                        ...(calendar_id ? { calendar_id: calendar_id } : {}),
                        ...(booking_type_id
                          ? { booking_type_id: booking_type_id }
                          : {}),
                        ...(userValue?.value
                          ? { user_id: userValue?.value }
                          : {}),
                        page: 1,
                        start: startDate,
                        end: endDate,
                      })
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <TableComponent
                  data={userBookingReports?.data}
                  columns={userReportListColumns({
                    eventId: event_id,
                    calendarId: calendar_id,
                    subCalendarId: booking_type_id,
                  })}
                  paginationData={{
                    current_page: userBookingReports?.current_page,
                    last_page: userBookingReports?.last_page,
                    total_items: userBookingReports?.total,
                    items_per_page: userBookingReports?.per_page,
                    from: userBookingReports?.from,
                    to: userBookingReports?.to,
                    first_page: 1,
                  }}
                  onPageChange={handlePageChange}
                  onTableSort={handleSort}
                  withCheckboxes={true}
                  onCheckItem={handleCheckItem}
                  onCheckAllItems={handleCheckAllItems}
                />
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  usersBySearch: state.SiteUsers.usersBySearch,
  userBookingReports: state.BookingsFeature.userBookingReports,
})

const mapDispatchToProps = dispatch => ({
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  getUserBookingReports: values => dispatch(getUserBookingReports(values)),
  resetUsersBySearch: () => dispatch(resetUsersBySearch()),
  downloadBookingUserReports: values =>
    dispatch(downloadBookingUserReports(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserReports))
